import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ArtikelLeverancierPrijzen } from '../dto/artikel-leverancier-prijzen';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class ArtikelLeverancierPrijzenService extends CrudService<ArtikelLeverancierPrijzen> {

  constructor(injector: Injector) { super(ArtikelLeverancierPrijzen, injector); }

}
